/* eslint-disable newline-per-chained-call */
/* eslint-disable consistent-return */
/* eslint-disable prefer-object-spread */
import { ChakraProvider, extendTheme } from "@chakra-ui/react"
import BeatTheme from "components/Beat/theme"
import { mergeDeep } from "components/Beat/utils/mergeDeep"
import React, { useEffect, useMemo, useState } from "react"
import tinycolor from "tinycolor2"
import { ThemeContext, ThemeState, useTheme } from "./useTheme"

export const BeatGlobalTheme: React.FC = ({ children }) => {
  const { theme } = useTheme()
  const globalTheme = theme

  return <ChakraProvider theme={globalTheme}>{children}</ChakraProvider>
}

export const BeatThemeProvider: React.FC<ThemeState> = ({ children, theme, logo, primaryColor }) => {
  const [data, setData] = useState<ThemeState>({ logo, primaryColor })

  const primaryColorTheme = useMemo(() => {
    if (primaryColor) {
      return {
        colors: {
          primary: primaryColor,
          brand: {
            50: tinycolor(primaryColor).brighten(5).toString(),
            100: tinycolor(primaryColor).brighten(10).toString(),
            200: tinycolor(primaryColor).brighten(20).toString(),
            300: tinycolor(primaryColor).brighten(30).toString(),
            400: tinycolor(primaryColor).brighten(40).toString(),
            500: tinycolor(primaryColor).brighten(50).toString(),
            600: primaryColor,
            700: tinycolor(primaryColor).darken(5).toString(),
            800: tinycolor(primaryColor).darken(10).toString(),
            900: tinycolor(primaryColor).darken(15).toString()
          }
        }
      }
    }
    if (theme) {
      return {
        colors: {
          primary: theme.colors.primary,
          brand: {
            50: tinycolor(theme.colors.primary).brighten(50).toString(),
            100: tinycolor(theme.colors.primary).brighten(40).toString(),
            200: tinycolor(theme.colors.primary).brighten(30).toString(),
            300: tinycolor(theme.colors.primary).brighten(20).toString(),
            400: tinycolor(theme.colors.primary).brighten(10).toString(),
            500: tinycolor(theme.colors.primary).brighten(5).toString(),
            600: theme.colors.primary,
            700: tinycolor(theme.colors.primary).darken(5).toString(),
            800: tinycolor(theme.colors.primary).darken(10).toString(),
            900: tinycolor(theme.colors.primary).darken(15).toString()
          }
        }
      }
    }
  }, [primaryColor])

  const themeContextValueProps = useMemo(
    () => ({
      ...data
    }),
    [data]
  )

  const finalTheme = useMemo(() => {
    if (primaryColor && !theme) {
      return extendTheme(mergeDeep(BeatTheme, primaryColorTheme))
    }
    if (theme) {
      return extendTheme(mergeDeep(BeatTheme, theme, primaryColorTheme))
    }

    return BeatTheme
  }, [primaryColor, theme])

  useEffect(() => {
    setData((prevState) => ({
      ...prevState,
      theme: finalTheme,
      logo,
      primaryColor
    }))
  }, [finalTheme])

  return (
    <ThemeContext.Provider value={themeContextValueProps}>
      <BeatGlobalTheme>{children}</BeatGlobalTheme>
    </ThemeContext.Provider>
  )
}
